<template>
  <div class="ibox">
    <div class="ibox-content father">

      <div class="text-center">
        <b>{{ currentCompany.name }}</b>
        <div>{{ currentCompany.cnpj | cnpj }}</div>
      </div>

      <div class="upload">

        <div class="icon" v-if="hasCertificate">
          <CheckCircleIcon size="4x"/>
        </div>

        <template v-else>

          <Upload class="upload" @changeFiles="setFile" accept=".pfx, .PFX">

            <UploadCloudIcon size="3x"/>
            <template v-if="hasTempCertificate">
              <p>{{ currentCompany.digitalCertificate.name }} {{ formatFileSize(currentCompany.digitalCertificate) }}</p>
            </template>

            <p v-if="!hasTempCertificate">
              Selecione ou arraste o seu certificado aqui
            </p>

          </Upload>

          <p v-if="hasTempCertificate" style="cursor: pointer" @click="currentCompany.digitalCertificate = null">Remover certificado</p>

          <input type="password" v-model="currentCompany.password" placeholder="Senha do certificado" class="form-control">
          <button :disabled="!hasTempCertificate"
                  @click="save"
                  class="btn btn-outline mt-3">Enviar</button>
        </template>

      </div>

    </div>
  </div>
</template>

<script>
  import MethodMixins from '@/components/company/MethodMixins'
  import Upload from '@/components/shares/specialTag/Upload'
  import { UploadCloudIcon, CheckCircleIcon } from 'vue-feather-icons'

  export default {
    components: { CheckCircleIcon, Upload, UploadCloudIcon },
    methods: {
      cancel() {
        // override method to disabled
      }
    },
    mixins: [MethodMixins],
    name: 'UploadCertificateCompany'
  }
</script>

<style scoped>

  .father {
    min-height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .upload {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
  }

  .icon {
    color: #0f9c74;
    text-align: center;
  }

  .btn {
    padding: inherit;
  }
</style>
